import Component from './TikTokPost.vue'
export default Component
